export const CARD_WIDTH = 210;
export const CARD_BUFFER = 40;
